export const replaceWindowHistory = (
  data: any,
  unused: string,
  url: string | URL | null,
) => {
  window.history.replaceState(data, unused, url)
}
